module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1151.b42e26db.png";